import { createContext, useContext, useState, ReactNode } from "react";

interface QualitySearchContextType {
  searchPhrase: string;
  setSearchPhrase: (value: string) => void;
}

const QualitySearchContext = createContext<QualitySearchContextType | undefined>(undefined);

export function QualitySearchProvider({ children }: { children: ReactNode }) {
  const [searchPhrase, setSearchPhrase] = useState("");

  return (
    <QualitySearchContext.Provider value={{ searchPhrase, setSearchPhrase }}>
      {children}
    </QualitySearchContext.Provider>
  );
}

export function useQualitySearch() {
  const context = useContext(QualitySearchContext);
  if (context === undefined) {
    throw new Error("useQualitySearch must be used within a QualitySearchProvider");
  }
  return context;
}

